import React from "react";
import { Link } from 'react-scroll';

function Cover() {
    return (
      <section className="hero-section">
        <div className="hero-background">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <div className="hero-spacer"></div>
            <h1 className="hero-title">
              Exploring Animal Worlds<br/>
              <span className="hero-title-accent">Intelligent Insights</span>
            </h1>
            <p className="hero-description">
              Multimedia AI analysis:<br/>
              Advanced Deep Learning for Animal Recognition in<br/>
              Images, Videos & Audio
            </p>
          </div>
        </div>
        <div className="hero-cta">
          <Link
            className="cta-button"
            activeClass="active"
            to="introduction"
            spy={true}
            smooth={true}
            offset={0}
            duration={500}
          >
            Learn more about us
            <span className="cta-arrow">↓</span>
          </Link>
        </div>
      </section>
    )
}
  
export default Cover
